export const ProjectFormBottomExtensions: ProjectFormBottomExtensionsItem[] = [];
export interface ProjectFormBottomExtensionsItem {
  sortIndex: number;
  Component: any;
}
